import { NgModule } from '@angular/core';
import { MetricPipe } from './metric/metric';
@NgModule({
	declarations: [MetricPipe],
	imports: [],
	exports: [MetricPipe]
})
export class PipesModule {}



// WEBPACK FOOTER //
// ./src/pipes/pipes.module.ts